import React from 'react';
import PropTypes from 'prop-types';
/* styles */
import './accordion.scss';

class Accordion extends React.PureComponent {
  render() {
    return (
      <div className={`glu-accordion${this.props.isOpened ? ' glu-accordion--opened' : ''}`}>
        <div className="glu-accordion__header">
          <div className="glu-flex cursor-pointer" onClick={this.props.toggleAccordion}>
            <span className="g-icon g-icon-chevron-down" />
            <div className="glu-accordion__header-title">{this.props.title}</div>
          </div>
        </div>
        {this.props.isOpened && this.props.children}
      </div>
    );
  }
}

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  isOpened: PropTypes.bool,
  toggleAccordion: PropTypes.func.isRequired,
};

Accordion.defaultProps = {
  title: '',
  isOpened: true,
};

export default Accordion;
